module.exports = __webpack_public_path__ + "static/media/icon-about.565cd0ea.svg";